import {
  getCompanyDisplayName,
  isPrivateCompanyIdentifier,
} from '../../../utils/companyHelpers';

export const CHART_SHARE_PRESETS = Object.freeze([
  {
    id: 'landscape',
    label: 'Landscape',
    dimensions: '1600 × 900',
    width: 1600,
    height: 900,
    presentation: { maxTicks: 10 },
  },
  {
    id: 'square',
    label: 'Square',
    dimensions: '1080 × 1080',
    width: 1080,
    height: 1080,
    presentation: { maxTicks: 8 },
  },
  {
    id: 'mobile',
    label: 'Mobile',
    dimensions: '1080 × 1350',
    width: 1080,
    height: 1350,
    presentation: { maxTicks: 7 },
  },
]);

export const DEFAULT_CHART_SHARE_PRESET_ID = 'mobile';

export const getChartSharePreset = (presetId) => (
  CHART_SHARE_PRESETS.find((preset) => preset.id === presetId)
  || CHART_SHARE_PRESETS.find((preset) => preset.id === DEFAULT_CHART_SHARE_PRESET_ID)
  || CHART_SHARE_PRESETS[0]
);

const safeFilenamePart = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const buildChartShareFilename = ({
  ticker,
  companyName,
  entityId,
  chartId = 'chart',
  presetId = DEFAULT_CHART_SHARE_PRESET_ID,
  date = new Date(),
}) => {
  const isoDate = date instanceof Date && !Number.isNaN(date.getTime())
    ? date.toISOString().slice(0, 10)
    : String(date || '').slice(0, 10);
  const companyFilePart = isPrivateCompanyIdentifier(ticker)
    ? getCompanyDisplayName(ticker, companyName)
    : ticker;
  const parts = [
    'softwareiq',
    safeFilenamePart(companyFilePart || entityId) || 'analytics',
    safeFilenamePart(chartId) || 'chart',
    safeFilenamePart(isoDate) || 'export',
    safeFilenamePart(presetId) || DEFAULT_CHART_SHARE_PRESET_ID,
  ];

  return `${parts.join('-')}.png`;
};

export const buildChartShareMetadata = ({
  metric,
  postingType,
  pivotLabel,
  selectedSeries = [],
  periodLabel,
  dateRange,
  extra,
}) => [
  metric,
  postingType,
  pivotLabel,
  Array.isArray(selectedSeries) && selectedSeries.length > 0
    ? selectedSeries.join(', ')
    : null,
  periodLabel,
  dateRange,
  extra,
].filter(Boolean).join(' · ');
